import { Params } from "@angular/router";
import { ModalService } from "../modules/shared/modal/modal.service";
import { PopupBlockedModalComponent } from "../modules/shared/popup-blocked-modal/popup-blocked-modal.component";

export const getUrlParamValue = (queryString: string, paramName: string): string | undefined => {
  if (!queryString) {
    return undefined;
  }
  return new URLSearchParams(queryString.replace(/^[^?]*\?/, '')).get(paramName) ?? undefined;
};

export const setQueryStringParam = (queryString: string, paramName: string, paramValue: string): string => {
  const searchParams = new URLSearchParams(queryString);
  searchParams.set(paramName, paramValue);
  return searchParams.toString();
};

// a repeated query param is typed string[] by Angular, which the backend's Map<String, String> can't bind
export const toSingleValuedParams = (params: Params): Record<string, string> => {
  const result: Record<string, string> = {};
  for (const [name, value] of Object.entries(params ?? {})) {
    result[name] = Array.isArray(value) ? value[0] : value;
  }
  return result;
};

export const appendQueryStringParam = (url: string, paramName: string, paramValue: string): string => {
  const fragmentStart = url.indexOf("#");
  const base = fragmentStart === -1 ? url : url.substring(0, fragmentStart);
  const fragment = fragmentStart === -1 ? "" : url.substring(fragmentStart);
  return base + (base.indexOf("?") === -1 ? "?" : "&") + `${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}` + fragment;
};

export const removeQueryStringParams = (url: string, ...paramNames: string[]): string => {
  let result = url;
  for (const paramName of paramNames) {
    const pattern = new RegExp(`([?&])${paramName}=[^&#]*(&|#|$)`);
    let previous: string;
    do {
      previous = result;
      result = result.replace(pattern, (_match, separator, next) => next === "&" ? separator : next);
    } while (result !== previous);
  }
  return result;
};

export const openPotentiallyBlockedWindow = async (url: string, modalService: ModalService<any>, target: "_blank" | "_top" = "_blank") => {
  const opened = window.open(url);

  if (!opened || opened.closed || typeof opened.closed === "undefined") {
    // popup blocked (first time on Safari/Opera/Chrome), so have the user open it by clicking a link, otherwise the 'opener' is null so the opened window can't be closed programmatically
    const modal: ModalService<PopupBlockedModalComponent> = modalService.create(PopupBlockedModalComponent);
    modal.component.href = url;
    modal.component.target = target;
    await modal.open();
  }
};
